import React from 'react';
import {
  makeStyles,
  Box,
} from '@material-ui/core';
// import { useTableOverviewContext } from './WhitePopup'

const useStyles = makeStyles((theme) => ({
  root:{
      paddingTop: theme.spacing(3),
  },
}));

interface WhitePopupActionProps {
  children : any
}
const WhitePopupAction: React.FC<WhitePopupActionProps> = ({
    children
}) => {

    const classes = useStyles();
    // const { color,variant } = useTableOverviewContext();

    return (
        <div className={classes.root}>
            <Box display="flex" justifyContent="center">
                {children}
            </Box>
        </div>
    )
}

export default WhitePopupAction;
